import ErrorBlock from '~components/Atoms/ErrorBlock';
import ErrorImage from '~components/Atoms/ErrorImage';
import HeartRate from '~components/icons/heart-rate';
import KoFace from '~components/icons/ko_face';
import RespiratoryRate from '~components/icons/respiratory-rate';

export interface iGenericErrorPage {
  status: number;
}

function GenericErrorPage({ status }: iGenericErrorPage) {
  return (
    <ErrorImage>
      <ErrorBlock position="left" icon={<HeartRate width={48} height={48} />}>
        {status}
      </ErrorBlock>
      <KoFace />
      <ErrorBlock icon={<RespiratoryRate width={48} height={48} />}>xx</ErrorBlock>
    </ErrorImage>
  );
}

export default GenericErrorPage;
